import { DurationFieldInternalValue } from './types';

export const secondsToParts = (total: number): DurationFieldInternalValue => {
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return {
    hours: String(hours),
    minutes: String(minutes),
    seconds: String(seconds),
  };
};

export const getInternalDefaultValue = (
  defaultValue?: number,
): DurationFieldInternalValue => {
  if (defaultValue !== undefined) {
    return secondsToParts(defaultValue);
  }

  return { hours: '', minutes: '', seconds: '' };
};

export const clamp = (val: number, max: number): number =>
  Math.min(Math.max(val || 0, 0), max);

export const getTotalSeconds = (
  internalValue: DurationFieldInternalValue,
): number => {
  const currentHours = clamp(Number(internalValue.hours), 99);
  const currentMinutes = clamp(Number(internalValue.minutes), 59);
  const currentSeconds = clamp(Number(internalValue.seconds), 59);

  return currentHours * 3600 + currentMinutes * 60 + currentSeconds;
};
